<template>
  <section class="mt-5">
    <h2>メンバーズクラブ会員登録申込</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li>申込入力</li>
        <li class="here">内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <h3>申込内容確認</h3>
      <p>
        以下のメールアドレスに「申込者情報の登録及び商品ご購入のお手続き」用のURLが記載されたメールをお送りいたします。<br />ご確認のうえ、「送信する」ボタンを押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <form>
            <dl id="dlConfirm">
              <dt>メールアドレス</dt>
              <dd>{{ mailAddress }}</dd>
              <dt>登録申込書番号</dt>
              <dd>{{ serial }}</dd>
              <dt>重要事項への同意</dt>
              <dd>同意する</dd>
            </dl>
            <div class="box-p-20 text-center mt-5">
              <button
                v-on:click="putData"
                id="btnSend"
                type="button"
                class="confirm-01"
              >
                送信する
              </button>
            </div>
            <div class="box-p-20 text-center">
              <router-link
                :to="{ path: '/serial', query: { ref: 'confirm' } }"
                class="btn d-inline-block"
                >入力画面へ戻る</router-link
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
// import Message from "@/modules/Message";
export default {
  data() {
    return {
      mailAddress: "",
      serial: "",
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSerialNo",
        [],
        true,
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.mailAddress = data.MailAddress;
          this.serial = data.SerialNo;
          //URL直打ち対策
          // if (this.mailAddress == "" || this.serial == "") {
          //   Message.error().fire({
          //     title: "不正なアクセスです。",
          //     didClose: () => {
          //       this.$router.push("/serial");
          //     },
          //   });
          // }
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putSerialNoMail",
        [],
        true,
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push("/serial/end");
        });
    },
  },
};
</script>
